export default __webpack_public_path__ + "static/media/EmptyPhoto.006b0edd.svg";